@if (hasAccess$ | async) {
  <div
    (click)="toggleReadSpeakerVisibility()"
    class="logo-container"
    [class.is-deactivated]="!isVisible"
    [matTooltip]="(!isVisible ? 'read-speaker.activated-tooltip' : 'read-speaker.deactivated-tooltip') | wording"
    matTooltipPosition="above">
    <div class="logo-first">
      <img
        src="assets/shared/images/read-speaker/logo-readspeaker.png"
        alt="ReadSpeaker logo"
        title="ReadSpeaker logo" />
    </div>
    <div class="logo-second">
      <div class="text-toggle">
        {{ (!isVisible ? 'read-speaker.activated' : 'read-speaker.deactivated') | wording }}
      </div>
      <img
        src="assets/shared/images/read-speaker/readspeaker_logo_without_sound_icon.png"
        alt="ReadSpeaker logo"
        title="ReadSpeaker logo" />
    </div>
  </div>
}
